import React from 'react';
import { Card as CardType, suitToSymbol, valueToString, Suit } from '../types/poker';
import './Card.css';

interface CardProps {
  card: CardType;
  key?: string;
}

const Card = ({ card }: CardProps) => {
  const getGradient = (suit: Suit): string => {
    switch (suit) {
      case Suit.HEARTS:
        return 'linear-gradient(to bottom, #ff4d4d, #cc0000)';  // light red to dark red
      case Suit.DIAMONDS:
        return 'linear-gradient(to bottom, #66b3ff, #0052cc)';  // light blue to dark blue
      case Suit.CLUBS:
        return 'linear-gradient(to bottom, #5cd65c, #1f7a1f)';  // light green to dark green
      case Suit.SPADES:
        return 'linear-gradient(to bottom, #666666, #1a1a1a)';  // light gray to dark gray
      default:
        return 'linear-gradient(to bottom, #666666, #1a1a1a)';
    }
  };

  return (
    <div 
      className="card"
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'min(70px, 20vw)',  // Responsive width
        height: 'min(100px, 28vw)', // Responsive height
        margin: 'min(5px, 1vw)',
        padding: 'min(10px, 2vw)',
        borderRadius: 'min(10px, 2vw)',
        background: getGradient(card.suit),
        color: 'white',
        fontWeight: 'bold',
        boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
        userSelect: 'none',
        fontFamily: 'Verdana, sans-serif'
      }}
    >
      {/* Top left corner rank and suit */}
      <div style={{
        position: 'absolute',
        top: 'min(5px, 1vw)',
        left: 'min(5px, 1vw)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 'min(20px, 5vw)',
        lineHeight: '1'
      }}>
        <div style={{ fontFamily: 'Verdana, sans-serif' }}>{valueToString(card.value)}</div>
        <div>{suitToSymbol[card.suit]}</div>
      </div>

      {/* Center large rank */}
      <div style={{
        fontSize: 'min(50px, 18vw)',
        fontWeight: 'bold',
        fontFamily: 'Verdana, sans-serif'
      }}>
        {valueToString(card.value)}
      </div>
    </div>
  );
};

export default Card; 